var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.557 11.942V8.057C20.557 3.614 16.942 0 12.5 0S4.443 3.614 4.443 8.057v3.885a2.2 2.2 0 00-1.464 2.072v8.789A2.2 2.2 0 005.176 25h14.648a2.2 2.2 0 002.197-2.197v-8.79a2.2 2.2 0 00-1.464-2.07zM5.908 8.057A6.6 6.6 0 0112.5 1.465a6.6 6.6 0 016.592 6.592v3.76h-1.465v-3.76c0-2.827-2.3-5.127-5.127-5.127a5.133 5.133 0 00-5.127 5.127v3.76H5.908v-3.76zm10.254 0v3.76H8.838v-3.76A3.666 3.666 0 0112.5 4.395a3.666 3.666 0 013.662 3.662zm4.395 14.746a.733.733 0 01-.733.732H5.176a.733.733 0 01-.733-.732v-8.79c0-.403.329-.732.733-.732h14.648c.404 0 .733.329.733.733v8.789z",
    fill: "#FF7D6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.746a2.2 2.2 0 00-2.197 2.197 2.2 2.2 0 001.465 2.072v2.323a.732.732 0 101.464 0v-2.323a2.2 2.2 0 001.465-2.072 2.2 2.2 0 00-2.197-2.197zm0 2.93a.733.733 0 11.002-1.467.733.733 0 01-.002 1.467z",
    fill: "#FF7D6B"
  })));
}
export default SvgLock;